export const reduxActions = {
  ALL_FAIL: "profile/all_fail",
  ALL_RESET: "profile/all_reset",
  ALL_STARTED: "profile/all_started",
  ALL_SUCCESS: "profile/all_success"
};
